import { ICountry } from "shared/api/api";


export const GET_COUNTRIES = 'GET_COUNTRIES';

export interface CountryState {
    countries: ICountry[];
}
